"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'login.form.title': '登录',
    'login.form.hero.title': '欢迎回来',
    'login.form.hero.description': '请使用您的凭据登录。',
    'login.form.hero.register_link_text': '如果您还不是会员，请',
    'login.form.hero.register_link': '在此注册',
};
